import React from "react";

export const LazyGuidedSellingPreview = React.lazy(() =>
  import("./GuidedSellingPreview").then(m => ({ default: m.GuidedSellingPreview })),
);

export const GUIDED_SELLING_PATH_ROOT = "/__guided-selling-preview";
export const GUIDED_SELLING_PATH = "/__guided-selling-preview/:screenIdx";
